const visit = require('unist-util-visit');

// Transformer, conforming to the gatsby remark plugin API
function transformer({ markdownAST }) {
  visit(markdownAST, 'link', node => {
    if (node.title) {
      return;
    }

    const textChild = node.children.find(child => child.type === 'text');
    if (textChild) {
      // eslint-disable-next-line no-param-reassign
      node.title = textChild.value;
    }
  });

  return markdownAST;
}

module.exports = transformer;

// Alternative export -- this conforms Remark's own plugin API
module.exports.remarkATitle = function attacher() {
  function transformerWrapper(tree) {
    return transformer({ markdownAST: tree });
  }

  return transformerWrapper;
};
